import React from 'react'

const Login = () => {
  return (
    <div style={{marginTop:"80px"}}>Login</div>
  )
}

export default Login